import React, { useEffect, useRef, useState } from 'react';
import './Modal.css';
import Backdrop from '../Backdrop/Backdrop';

const Modal = (props) => {
    const modalRef = useRef(null);
    const [modalHeight, setModalHeight] = useState(0);

    const updateModalHeight = () => {
        if (modalRef.current) {
            const { height } = modalRef.current.getBoundingClientRect();
            setModalHeight(height);
        }
    };

    useEffect(() => {
        updateModalHeight(); // Initial height update when the component mounts

        const observer = new MutationObserver(updateModalHeight); // Observe changes in the modal
        if (modalRef.current) {
            observer.observe(modalRef.current, {
                childList: true, // Watch for added or removed child nodes
                subtree: true, // Watch all descendants
                attributes: true, // Watch for attribute changes (like styles)
                characterData: true, // Watch for changes to text content
            });
        }

        // Cleanup function to disconnect the observer
        return () => {
            observer.disconnect();
        };
    }, [props.show]); // Update when `show` prop changes

    useEffect(() => {
        updateModalHeight(); // Update height when `children` change
    }, [props.children]); // Update height when `children` change

    return (
        <>
            <Backdrop show={props.show} clicked={props.modalClosed} />
            <div
                className="Modal"
                ref={modalRef}
                style={{
                    transform: props.show ? 'translateY(0)' : 'translateY(-1000vh)',
                    opacity: props.show ? '1' : '0',
                }}
            >
                {props.show && props.children}
            </div>
            {/* Blank div that adjusts height based on the modal height */}
            {props.show && <div style={{
                height: window.innerWidth >= 1024 ? modalHeight - 650 : 0
            }}></div>}
            </>
    );
};

export default Modal;
